import { IOrderBy } from '../typings'

export const orderByToArray = (opts: IOrderBy[]): string[] =>
  opts.reduce<string[]>((prev, { value }) => [...prev, value], [])
